import { ref as R, watch as _, getCurrentInstance as T, onUnmounted as M, defineComponent as B, computed as E, openBlock as S, createElementBlock as p, normalizeStyle as v, Fragment as w, renderList as P, mergeProps as V, toHandlers as G, createElementVNode as y, createVNode as L, renderSlot as x, createTextVNode as $, toDisplayString as z, createCommentVNode as O } from "vue";
const F = "1em", W = {
  top: {
    container: { flexDirection: "column" },
    legend: { order: -1, margin: 0, marginBottom: F }
  },
  right: {
    container: {},
    legend: {
      flexDirection: "column",
      margin: 0,
      marginLeft: F
    }
  },
  bottom: {
    container: { flexDirection: "column" },
    legend: {}
  },
  left: {
    container: {},
    legend: {
      flexDirection: "column",
      order: -1,
      margin: 0,
      marginRight: F
    }
  }
};
function u(i) {
  return Number(i.toPrecision(15));
}
function X({
  el: i,
  onResize: f
}) {
  const t = R(0), r = R(0), d = new ResizeObserver((m) => {
    if (!i.value) return;
    const c = m[0];
    t.value = c.contentRect.width, r.value = c.contentRect.height;
    /* istanbul ignore else -- @preserve */
    f && f(t.value, r.value);
  });
  _(
    i,
    (m, c) => {
      c && d.unobserve(c), m && d.observe(m);
    },
    { immediate: !0 }
  );
  const b = () => {
    d.disconnect();
  };
  return T() && M(() => {
    b();
  }), { width: t, height: r, stop: b };
}
const N = [
  "#FF6384",
  "#36A2EB",
  "#FFCE56",
  "#F58231",
  "#46F0F0",
  "#D2F53C",
  "#911EB4",
  "#F032E6",
  "#3CB44B",
  "#FFE119",
  "#E6194B",
  "#FABEBE",
  "#008080",
  "#E6BEFF",
  "#0082C8",
  "#AA6E28",
  "#FFFAC8",
  "#800000",
  "#AAFFC3",
  "#808000",
  "#FFD8B1",
  "#000080",
  "#808080",
  "#000000"
], I = () => {
  let i = 0, f = !1;
  return () => {
    i === 0 && f && console.warn("Ran out of default colors, reusing colors");
    const r = N[i];
    return i = (i + 1) % N.length, i === 0 && (f = !0), r;
  };
}, j = ["title"], H = /* @__PURE__ */ B({
  __name: "DonutSections",
  props: {
    sections: {},
    startAngle: {},
    total: {}
  },
  emits: ["section-click", "section-mouseenter", "section-mouseleave", "section-mouseover", "section-mouseout", "section-mousemove"],
  setup(i, { emit: f }) {
    const t = i, r = f, d = E(() => ({
      transform: `rotate(${t.startAngle}deg)`
    })), b = E(() => {
      let s = 0;
      const C = I(), D = [];
      t.sections.forEach((e) => {
        const l = u(360 * (e.value / (t.total || 1))), o = e.color || C(), g = u(s + l);
        if (g > 180) {
          const h = u(180 - s), A = u(l - h);
          D.push(
            { baseSection: e, degree: h, color: o },
            { baseSection: e, degree: A, color: o }
          );
        } else
          D.push({ baseSection: e, degree: l, color: o });
        s = g, s >= 180 && (s = u(s - 180));
      });
      const k = [];
      s = 0;
      let n = 0;
      return D.forEach((e) => {
        if (e.degree === 0) return;
        let [l, o] = ["cdc-section-right", -180];
        s >= 180 && ([l, o] = ["cdc-section-left", 180]);
        const g = {
          backgroundColor: e.color,
          transform: `rotate(${u(o + e.degree)}deg)`
        }, h = { transform: `rotate(${n}deg)` };
        s = u(s + e.degree), s === 180 ? n = 0 : n = u(n + e.degree);
        const A = {
          click: (a) => r("section-click", { section: e.baseSection, event: a }),
          mouseenter: (a) => r("section-mouseenter", { section: e.baseSection, event: a }),
          mouseleave: (a) => r("section-mouseleave", { section: e.baseSection, event: a }),
          mouseover: (a) => r("section-mouseover", { section: e.baseSection, event: a }),
          mouseout: (a) => r("section-mouseout", { section: e.baseSection, event: a }),
          mousemove: (a) => r("section-mousemove", { section: e.baseSection, event: a })
        };
        k.push({
          baseSection: e.baseSection,
          degree: e.degree,
          color: e.color,
          className: l,
          fillerStyles: g,
          sectionStyles: h,
          listeners: A
        });
      }), k;
    });
    return (m, c) => (S(), p("div", {
      class: "cdc-sections",
      style: v(d.value)
    }, [
      (S(!0), p(w, null, P(b.value, (s, C) => (S(), p("div", V({
        key: C,
        class: ["cdc-section", s.className],
        style: s.sectionStyles
      }, G(s.listeners, !0)), [
        y("div", {
          class: "cdc-filler",
          style: v(s.fillerStyles),
          title: s.baseSection.label || ""
        }, null, 12, j)
      ], 16))), 128))
    ], 4));
  }
}), U = ["title"], q = /* @__PURE__ */ B({
  __name: "DonutChart",
  props: {
    size: { default: 250 },
    unit: { default: "px" },
    thickness: { default: 20 },
    text: { default: "" },
    autoAdjustTextSize: { type: Boolean, default: !0 },
    background: { default: "#ffffff" },
    foreground: { default: "#eeeeee" },
    sections: { default: () => [] },
    total: { default: 100 },
    hasLegend: { type: Boolean, default: !1 },
    legendPlacement: { default: "bottom" },
    startAngle: { default: 0 },
    suppressValidationWarnings: { type: Boolean, default: !1 }
  },
  emits: ["section-click", "section-mouseenter", "section-mouseleave", "section-mouseover", "section-mouseout", "section-mousemove"],
  setup(i, { emit: f }) {
    const t = i, r = f, d = R(), b = E(() => {
      const n = I();
      return t.sections.map((l, o) => ({
        label: l.label || `Section ${o + 1}`,
        value: `${l.value} (${u(l.value / (t.total || 1)) * 100}%)`,
        styles: {
          backgroundColor: l.color || n()
        }
      }));
    }), m = R("1em"), c = () => {
      if (!t.autoAdjustTextSize) {
        m.value = "1em";
        return;
      }
      const n = 0.08;
      let e = t.size;
      if (t.unit !== "px") {
        /* istanbul ignore else -- @preserve */
        d.value ? e = d.value.clientWidth : e = null;
      }
      m.value = e ? `${u(e * n)}px` : "1em";
    };
    X({
      el: d,
      onResize: c
    }), _(
      () => t.autoAdjustTextSize,
      (n) => {
        n ? window.addEventListener("resize", c) : window.removeEventListener("resize", c), c();
      }
    );
    const s = E(() => t.hasLegend ? W[t.legendPlacement] : null), C = E(() => {
      const n = `${t.size}${t.unit}`;
      return {
        width: n,
        paddingBottom: n,
        backgroundColor: t.foreground
      };
    }), D = E(() => {
      const n = 100 - t.thickness, e = `${n}%`, l = `calc(50% - ${n / 2}%)`;
      return {
        height: e,
        width: e,
        top: l,
        left: l,
        backgroundColor: t.background
      };
    }), k = E(() => ({
      fontSize: m.value
    }));
    return _(
      () => t.size,
      () => {
        t.suppressValidationWarnings || t.size < 0 && console.warn("vue-css-donut-chart: `size` must be a positive number");
      },
      { immediate: !0 }
    ), _(
      () => t.thickness,
      () => {
        t.suppressValidationWarnings || (t.thickness < 0 || t.thickness > 100) && console.warn("vue-css-donut-chart: `thickness` must be between 0 and 100");
      },
      { immediate: !0 }
    ), _(
      [() => t.total, () => t.sections],
      () => {
        if (t.suppressValidationWarnings) return;
        if (t.total < 0) {
          console.warn("vue-css-donut-chart: `total` must be a positive number");
          return;
        }
        u(
          t.sections.reduce((e, l) => e + (typeof l.value == "number" ? l.value : 0), 0)
        ) > t.total && console.warn("vue-css-donut-chart: Sum of section values exceeds `total`");
      },
      { immediate: !0, deep: !0 }
    ), (n, e) => {
      var l;
      return S(), p("div", {
        class: "cdc-container",
        style: v((l = s.value) == null ? void 0 : l.container)
      }, [
        y("div", {
          ref_key: "donutEl",
          ref: d,
          class: "cdc",
          style: v(C.value)
        }, [
          L(H, {
            sections: t.sections,
            "start-angle": t.startAngle,
            total: t.total,
            onSectionClick: e[0] || (e[0] = (o) => r("section-click", o.section, o.event)),
            onSectionMouseenter: e[1] || (e[1] = (o) => r("section-mouseenter", o.section, o.event)),
            onSectionMouseleave: e[2] || (e[2] = (o) => r("section-mouseleave", o.section, o.event)),
            onSectionMouseover: e[3] || (e[3] = (o) => r("section-mouseover", o.section, o.event)),
            onSectionMouseout: e[4] || (e[4] = (o) => r("section-mouseout", o.section, o.event)),
            onSectionMousemove: e[5] || (e[5] = (o) => r("section-mousemove", o.section, o.event))
          }, null, 8, ["sections", "start-angle", "total"]),
          y("div", {
            class: "cdc-overlay",
            style: v(D.value)
          }, [
            y("div", {
              class: "cdc-text",
              style: v(k.value)
            }, [
              x(n.$slots, "default", {}, () => [
                $(z(n.text), 1)
              ])
            ], 4)
          ], 4)
        ], 4),
        x(n.$slots, "legend", {}, () => {
          var o;
          return [
            n.hasLegend ? (S(), p("div", {
              key: 0,
              class: "cdc-legend",
              style: v((o = s.value) == null ? void 0 : o.legend)
            }, [
              (S(!0), p(w, null, P(b.value, (g, h) => (S(), p("span", {
                key: h,
                class: "cdc-legend-item",
                title: g.value
              }, [
                y("span", {
                  class: "cdc-legend-item-color",
                  style: v(g.styles)
                }, null, 4),
                y("span", null, z(g.label), 1)
              ], 8, U))), 128))
            ], 4)) : O("", !0)
          ];
        })
      ], 4);
    };
  }
}), K = {
  install(i) {
    i.component("VcDonut", q);
  }
};
export {
  q as VcDonut,
  K as default
};
//# sourceMappingURL=vcdonut.mjs.map
